import type { FC } from 'react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OneSelect } from '@yy/one-ui'
import type { IOneSelectProps } from '@yy/one-ui/lib/OneSelect'
import { FormItem } from '@/bizComponent/AntdForm/DynamicFormItemGroup'
import RULES from '../../../../rules'

interface IProps extends IOneSelectProps<any> {
  required?: boolean
  defaultValue?: any
  taxTypeOpt: {
    label: string
    value: any
  }[]
}

const { Option } = OneSelect

const Select: React.FC<Omit<IProps, 'required'>> = (props) => {
  const { taxTypeOpt, ...args } = props
  return (
    <OneSelect {...args}>
      {taxTypeOpt.map((item) => (
        <Option key={item.value} value={item.value} data-id={`provider_tax_type${item.value}`}>
          {item.label}
        </Option>
      ))}
    </OneSelect>
  )
}

const TaxNoTypeField: FC<IProps> = (props) => {
  const { required = false, taxTypeOpt, defaultValue } = props

  const { t } = useTranslation()

  return (
    <FormItem
      name="provider_tax_type"
      required={required}
      label={t('logistics.create.taxType')}
      initialValue={defaultValue}
      rules={RULES.provider_tax_type({
        isRequired: required,
      })}
    >
      <Select taxTypeOpt={taxTypeOpt} placeholder={t('common.select.placeholder')} />
    </FormItem>
  )
}

export default TaxNoTypeField
